import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import { EDSApplication, Footer } from '@ellucian/react-design-system/core/es';
import { createEDSTheme } from '@ellucian/react-design-system/core/es/themes';
import { IconSprite } from '@ellucian/ds-icons/lib';
import LoginForm from './LoginForm';
import HeaderBar from '@ellucian/react-design-system/core/es/HeaderBar';
import queryString from 'query-string';
import { CssBaseline } from '@mui/material';
import { getUserLocale } from '../controllerApp/Utils/DateTimeUtils';
import { HeaderBarLogoComponent } from '../controllerApp/components/HeaderBarLogoComponent';
import PageLoadIndicator from '../controllerApp/components/PageLoadIndicator';

const customTheme = createEDSTheme('light', {
  breakpoints: {
    values: {
      lg: '1500',
    },
  },
});

const parsedQuery = queryString.parse(window.location.search);

const id = 'Login';
class LoginApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      messages: null,
    };
  }

  componentDidMount() {
    fetch('api/messages')
      .then(response => response.json())
      .then(messages => this.setState({ messages }));
  }

  render() {
    let children;
    const locale = getUserLocale();
    if (this.state.messages) {
      document.title = this.state.messages['controller.login.title'];

      children = (
        <IntlProvider locale={locale} messages={this.state.messages}>
          <EDSApplication locale={locale} theme={customTheme}
            labelOverrides={{
              'component.Logo.logo': this.state.messages['controller.logo.ariaLabel'],
              'component.TextField.hidePassword': this.state.messages['controller.textField.hidePassword'],
              'component.TextField.passwordHide': this.state.messages['controller.textField.passwordHide'],
              'component.TextField.passwordShow': this.state.messages['controller.textField.passwordShow'],
              'component.TextField.showPassword': this.state.messages['controller.textField.showPassword'],
            }}
          >
            <CssBaseline />
            <IconSprite />
            <div id={`${id}_Container`} className="loginContent">
              <HeaderBar position="static" id={`${id}_HeaderBar`}
                SearchTextFieldProps={{ inputProps: { 'aria-label': this.state.messages['controller.textField.search'] } }}
                logo={<HeaderBarLogoComponent id={id}
                  ariaLabel={this.state.messages['controller.logo.ariaLabel']}
                />}
              />
              <LoginForm hasLoginError={parsedQuery.error} />
            </div>
            <Footer footerText={this.state.messages['app.footer.copyright']} />
          </EDSApplication>
        </IntlProvider>
      );
    } else {
      children = (
        <EDSApplication locale={locale} theme={customTheme}>
          <PageLoadIndicator className="loadingIndicator" />
        </EDSApplication>
      );
    }

    return <div>{children}</div>;
  }
}

export default LoginApp;
